import React, { Suspense, useEffect, useState, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListingLayout from "../../Components/UI/ListingLayout";
import { generateCard } from "../../Stores/SlickCareProfiles/actions";
import { useStyles } from "./style";
import { CircularProgress } from "@material-ui/core";

import { posterStyleConfig } from "../../Data/posterFilters";
import { toggleInstruction } from "../../Stores/Reviews/actions";
const InstructionModal = lazy(() => import("../ReviewCard/InstructionModal"));

const ReviewPoster = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { activeLocation, posterPDF, isGenerating } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );
  const { posterFilters } = useSelector((state) => state.FilterReducer);

  const [pdfString, setPdfString] = useState("");
  const [loader, setLoader] = useState(true);

  let loading = loader || isGenerating;

  const onSuccess = (blobPDF) => {
    let reader = new FileReader();
    reader.readAsDataURL(blobPDF);
    reader.onloadend = () => {
      let base64String = reader.result;
      setPdfString(base64String);
    };
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const bodyFormData = new FormData();
      bodyFormData.append("location_ids[0]", activeLocation?.id ?? "");
      bodyFormData.append("bg_type", posterFilters.bg_type ?? "");

      bodyFormData.append(
        "bg_color",
        posterFilters.bg_type === "solid"
          ? posterFilters.bg_color
          : posterStyleConfig[posterFilters?.style_id]?.bg_color ?? ""
      );
      bodyFormData.append(
        "box_color",
        posterFilters.bg_type === "solid"
          ? posterFilters.box_color
          : posterStyleConfig[posterFilters?.style_id]?.box_color ?? ""
      );

      bodyFormData.append(
        "text_color",
        posterStyleConfig[posterFilters?.style_id]?.text_color ?? ""
      );
      bodyFormData.append(
        "bg_path",
        posterStyleConfig[posterFilters?.style_id]?.bg_path ?? ""
      );

      dispatch(
        generateCard(
          {
            data: bodyFormData,
            type: "Poster",
            title: activeLocation?.title,
          },
          onSuccess
        )
      );
      setLoader(false);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [posterFilters, activeLocation]);

  return (
    <>
      <ListingLayout
        title="Poster"
        item="ENQUIRIES"
        hideAdd={true}
        hasFilter={false}
        showLocationToggle={true}
        hasCardActions={true}
        onCardAction={() => {
          dispatch(toggleInstruction({ open: true }));
        }}
        cardActionTitle={"Order Posters"}
        hideOrder={true}
      >
        <>
          {loading ? (
            <div className={classes.loaderWrap}>
              <CircularProgress size="40px" />
            </div>
          ) : (
            <embed src={`${pdfString}`} width={"100%"} height={800} />
          )}
        </>
      </ListingLayout>
      <Suspense fallback={null}>
        <InstructionModal />
      </Suspense>
    </>
  );
};

export default ReviewPoster;
